import { Credit } from '../../models/credit';

export interface PackHttp {
  id: string;
  credit_total: number;
  credit_free?: number;
  price_net: number;
  price_gross: number;
  special_label?: string;
  special_description?: string;
}

export interface OffersHttp {
  items: PackHttp[];
  total_results: number;
}

export interface OrderHttp {
  id: string;
  reference: string;
  created_at: string;
  balance: number;
}

export const fromPackHttpToPack = (packHttp: PackHttp): Credit.Pack => {
  return {
    id: packHttp.id,
    creditTotal: packHttp.credit_total,
    creditFree: packHttp.credit_free,
    priceNet: packHttp.price_net,
    priceGross: packHttp.price_gross,
    specialLabel: packHttp.special_label,
    specialDescription: packHttp.special_description,
    isSpecialPack: !!packHttp.special_label,
  };
};

export const fromOrderHttpToOrder = (orderHttp: OrderHttp): Credit.Commande => {
  return {
    id: orderHttp.id,
    reference: orderHttp.reference,
    date: new Date(orderHttp.created_at),
    totalCredit: orderHttp.balance,
  };
};
